import React from 'react';

import { MemberList } from '@components/admin/members/MemberList';

export const MembershipForms: React.FC = () => <MemberList type="membershipForms" />;
